import { render, staticRenderFns } from "./loginImage.vue?vue&type=template&id=5bd21f3b&scoped=true&"
import script from "./loginImage.vue?vue&type=script&lang=js&"
export * from "./loginImage.vue?vue&type=script&lang=js&"
import style0 from "./loginImage.vue?vue&type=style&index=0&id=5bd21f3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd21f3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\taiqiu\\back-end\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd21f3b')) {
      api.createRecord('5bd21f3b', component.options)
    } else {
      api.reload('5bd21f3b', component.options)
    }
    module.hot.accept("./loginImage.vue?vue&type=template&id=5bd21f3b&scoped=true&", function () {
      api.rerender('5bd21f3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/components/loginImage.vue"
export default component.exports